import { get, compact, map } from "lodash"
import moment from "moment"
import { Typography, Chip } from "@mui/material"
import { Link } from "react-router-dom"
import Tooltip from "components/material/tooltip"
import InfoButton from "components/info-button"
import Ellipsable from "components/ellipsable"

export const ALL_DATASET_ACCESS_TEAM = {
  ALIAS: "all_dataset_access_team",
  NAME: "All Dataset Access Team",
}

// compact removes the direct chip when its false
export const makeSourcesElementRender = (account) => ({ direct, teams }) => compact([
  direct && <Chip key="direct" color="secondary" label="Direct" />,
  ...map(teams, team => <Chip
    key={team.id}
    component={Link}
    variant="outlined"
    label={team.name}
    color="primary"
    to={`/${account}/home/teams/${team.alias}/members`}
  />),
])

function getInfoPoints(dataset) {
  const { typeId, description, availability, expiration } = dataset
  const common = [{ primary: "Description", secondary: description, className: "description" }]
  // Risk models have more specific information to display
  if (typeId === "model") {
    return [
      { primary: "Model History", secondary: moment(get(availability, "securitiesStart")).format("MMM D, YYYY") },
      { primary: "Expiration Date", secondary: moment(expiration).format("MMM D, YYYY") },
      ...common,
    ]
  }
  return common
}

export const makeDatasetElementRender = (account, role, entitlementsEnabled, width) => {
  const DatasetElement = (dataset) => {
    const { id, name, description, expiration, availability } = dataset
    let tooltipElement = null

    if (description || expiration || availability) {
    // [TODO] [#184018795] JSX shouldn't be in selectors or models
      tooltipElement = <Tooltip title="More info" className="more-info">
        <span>
          <InfoButton items={getInfoPoints(dataset)} />
        </span>
      </Tooltip>
    }

    const nameElement = <>
      <Ellipsable width={width}>{role === "admin" && entitlementsEnabled ? <Link to={`/${account}/home/data-cloud/dataset/${id}/report`}>{name}</Link> : <span>{name}</span>}</Ellipsable>
      <Typography variant="subtitle2" component="h5">{id}</Typography>
    </>

    return <div className="flex">
      <div className="name">
        {role === "admin" && entitlementsEnabled ? <Link className="name" component="div" to={`/${account}/home/data-cloud/dataset/${id}`}>{nameElement}</Link> : nameElement}
      </div>
      {tooltipElement}
    </div>
  }
  DatasetElement.displayName = "DatasetElement"
  return DatasetElement
}
